import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="transaction-details"
export default class extends Controller {
  toggle(event) {
    event.preventDefault()

    const button = event.currentTarget
    const targetId = button.dataset.transactionDetailsTargetValue
    const detailsRow = document.getElementById(targetId)

    if (detailsRow) {
      const isHidden = detailsRow.classList.contains('hidden')

      if (isHidden) {
        // Show details
        detailsRow.classList.remove('hidden')
        button.textContent = 'Hide'
        button.classList.add('text-gray-600')
        button.classList.remove('text-blue-600')
      } else {
        // Hide details
        detailsRow.classList.add('hidden')
        button.textContent = 'View'
        button.classList.add('text-blue-600')
        button.classList.remove('text-gray-600')
      }
    }
  }
}
